import StackRankPqRange from './StackRankPqRange';
export default StackRankPqRange;
